import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowBottomLeftCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.5 14.4395V11H7V17H13V15.5H9.56055L14.0605 11L13 9.93945L8.5 14.4395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowBottomLeftCorner;
